const checkPhone = (phone) => {
    if (phone.length != 9) {
        return "El teléfono debe tener 9 digitos";
    }
    if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone)) {
        return "Debes ingresar un teléfono válido";
    }
};

export default checkPhone
